import AddIcon from "@mui/icons-material/Add";
import AddAPhotoIcon from "@mui/icons-material/AddAPhoto";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import VideoLibraryIcon from "@mui/icons-material/VideoLibrary";
import {Typography, Zoom} from "@mui/material";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import axios from "axios";

import React, {useEffect, useState} from "react";
import {Lightbox} from "react-modal-image";
import {Document, Page, pdfjs} from "react-pdf";
import ReactPlayer from "react-player";
import {connect} from "react-redux";
import {makeStyles} from "tss-react/mui";
import {v4 as uuidv4} from "uuid";
import {config_UPTIME} from "../../../../Constants";
import {
  CreateInternalAttachment,
  CreateManufacturerAttachment,
} from "../../../../actions/machineAttachments";
import {
  getSingleMachine,
  getinternalattachments,
  getmanufacturerattachments,
} from "../../../../actions/machines";
import {createGenericAttachment} from "../../../../actions/objects";
import {canUserPerformAction} from "../../../../shared-functions/userrights";
import {Theme247} from "../../../../styles/Theme247";
import {ApplyStyle as _s} from "../../../../utils/ApplyStyle";
import DocsAccordian from "./DocsAccordian";
import UploadAttachmentModal from "../../../../components/UploadAttachmentModal";
import {categoryItems, docs_enum, getFileExtention} from "../../../../utils/helpers";
import {DownloadDone} from "@mui/icons-material";
import mime from "mime";
import {ReactComponent as DropFileSvg} from "../../../../assets/DropFile.svg";
import {clsx} from "clsx";
import DragAndDropAccordian from "./DragAndDropAccordian";
import { getItem } from "../../../../utils/DataProtection";

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
var video_key = 0;
export default connect(
  ({
    machines,
    internalAttachments,
    manufacturerAttachments,
    i18n,
    profile,
  }) => ({
    machines,
    internalAttachments,
    manufacturerAttachments,
    i18n,
    profile,
  }),
  {
    CreateInternalAttachment,
    CreateManufacturerAttachment,
    getSingleMachine,
    getinternalattachments,
    getmanufacturerattachments,
    createGenericAttachment,
  }
)((props) => {
  const i18n = props.i18n;

  const [target, setTarget] = useState();

  const [showButtn, setShowButton] = useState(true); // to avoid double click

  const [numPages, setnumPages] = useState(null);
  const [pageNumber, setpageNumber] = useState(1);
  const [isOpenPDF, setisOpenPDF] = useState(false);
  const [large, setlarge] = useState("");
  const [openDialog, setopenDialog] = useState(false);
  const [openDialogVideo, setopenDialogVideo] = useState(false);
  const [nextDisabled, setnextDisabled] = useState(false);
  const [prevDisabled, setprevDisabled] = useState(true);
  const [pdfLink, setpdfLink] = useState("");
  const [titleManu, settitleManu] = useState("");
  const [titleInternal, settitleInternal] = useState("");
  const [description, setdescription] = useState("");
  const [videoUrl, setvideoUrl] = useState();

  const [UploadDialog, setUploadDialog] = useState(false);
  const [fileid, setfileid] = useState();
  const [uploadUrl, setuploadUrl] = useState();
  const [bucketid, setbucketid] = useState();
  const [Newfile, setNewfile] = useState();
  const [fileVersion, setFileVersion] = useState("");

  const [UploadDialogInternal, setUploadDialogInternal] = useState(false);
  const [fileidInternal, setfileidInternal] = useState();
  const [uploadUrlInternal, setuploadUrlInternal] = useState();
  const [bucketidInternal, setbucketidInternal] = useState();
  const [NewfileInternal, setNewfileInternal] = useState();
  const [fileVersionInternal, setFileVersionInternal] = useState();

  const [attachmentCategory, setAttachmentCategory] = useState("");

  const [descriptionInternal, setdescriptionInternal] = useState("");
  const [values, setValues] = useState({
    showPassword: false,
  });

  const onDocumentLoadSuccess = (totalPages) => {
    setnumPages(totalPages);
    if (totalPages == 1) {
      setnextDisabled(true);
    }
  };
  const handleCloseDialog = () => {
    setopenDialog(false);
  };
  const handleCloseDialogVideo = () => {
    setopenDialogVideo(false);
  };
  const handleNextPage = () => {
    setpageNumber(pageNumber + 1);
    if (pageNumber > 0) {
      setprevDisabled(false);
    }
    if (pageNumber == numPages - 1) {
      setnextDisabled(true);
    }
  };

  const handlePrevPage = () => {
    setpageNumber(pageNumber - 1);
    if (pageNumber > 1) {
      setnextDisabled(false);
    }
    if (pageNumber == 2) {
      setprevDisabled(true);
    }
  };
  const handleClickOpen = () => {
    setUploadDialog(true);
  };

  const handleClose = () => {
    setfileid("");
    setUploadDialog(false);
  };
  const handleClickOpenInternal = () => {
    setfileidInternal("");
    setUploadDialogInternal(true);
  };

  const handleChangeDropFile = (e) => {
    let file = e.target.files[0];
    // if (file.name.includes(".")) {
    //     setAlertText("Invalid File Extension !");
    // }
    setTarget(e);
    setNewfileInternal(file);

    setfileidInternal("");

    handleNewFileInternal(e);

    setUploadDialogInternal(true);
    $("#dropzone").hide();
    $(".docs_accordian").show();
  };

  const handleCloseInternal = () => {
    setUploadDialogInternal(false);
    setfileidInternal("");
  };
  const showPDF = (link) => {
    setopenDialog(true);
    setpdfLink(link);
    setnumPages(null);
    setpageNumber(1);
    setprevDisabled(true);
    setnextDisabled(false);
  };

  const {machines} = props;

 
  const [files, setFiles] = useState([]);


  // useEffect(() => {
  //   if (machines.equipment != undefined) {
  //     var tempArr = [];
  //     var tempArr1 = [];
  //     if (machines.equipment.hasattachment != undefined) {
  //       machines.equipment.hasattachment.map((x, k) => {
  //         if (
  //           x.attachment?.specifier == "internal attachment" &&
  //           x.attachment.file != null
  //         ) {
  //           const obj = {
  //             nodeid: x.attachment.nodeid,
  //             title: x.attachment.title,
  //             description: x.attachment.description,
  //             url: x.attachment.file.url,
  //             fileid: x.attachment.file.fileid,
  //             mimetype: x.attachment.file.mimetype,
  //           };
  //           tempArr.push(obj);
  //         } else if (
  //           x.attachment?.specifier == "manufacturer attachment" &&
  //           x.attachment.file != null
  //         ) {
  //           const obj = {
  //             nodeid: x.attachment.nodeid,
  //             title: x.attachment.title,
  //             description: x.attachment.description,
  //             url: x.attachment.file.url,
  //             fileid: x.attachment.file.fileid,
  //             mimetype: x.attachment.file.mimetype,
  //           };
  //           tempArr1.push(obj);
  //         }
  //       });
  //     }
  //     setAttachmentInternal(tempArr);
  //     setAttachmentManufacturer(tempArr1);
  //   }
  // }, [machines]);

  const showVIDEO = (link) => {
    setvideoUrl(link);
    setopenDialogVideo(true);
  };
  const [AttachmentNodeid, setAttachmentNodeid] = useState();

  const handleNewFileInternal = (e) => {
    e.preventDefault();
    var file = e.target.files[0];
    if (e.target.files.length == 0) {
      return false;
    }
    const exstention = getFileExtention(file?.type);
    setNewfileInternal(file);
    const user_token = getItem("user");
    const url = config_UPTIME.url.API_URL + "/files";
    const method = "POST";
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + JSON.parse(user_token),
      },
    };

    const nodeId = config_UPTIME.url.UPTIME_DEFAULT_URL + uuidv4();
    const exstension_payload = [{nodeid: nodeId, extension: exstention}];
    setAttachmentNodeid(nodeId);

    const response = axios
      .post(
        url,
        {
          count: 1,
          extensions: exstension_payload,
        },
        config
      )
      .then((res) => {
        var arr = [];
        setfileidInternal(res.data[0].fileid);
        setuploadUrlInternal(res.data[0].url);

        setbucketidInternal(res.data[0].bucketid);

        setFileVersionInternal(res.data[0].fileversion);

        return res;
      })
      .catch(function(error) {
        //console.log(error);
      });
    return response;
  };
  const submitFormManufacturer = (e) => {
    e.preventDefault();
    /* if (description == "") {
        alert('Please Enter Description !')
        return;
    } */
    const url = uploadUrl;
    const config = {
      headers: {
        "Content-Type": Newfile.type,
        "Access-Control-Allow-Origin": "*",
      },
    };
    const response = axios
      .put(url, Newfile, config)
      .then((res) => {
        //console.log(res.data)
      })
      .catch(function(error) {
        //console.log(error);
      });
    const lang = "de";
    const file = {
      fileid: fileid,
      mimetype: Newfile?.type,
      bucketid: bucketid,
      fileversion: fileVersion,
    };
    const isattachmentof = machines?.equipment?.nodeid;

    const specifier = "manufacturer attachment";
    const title = titleManu === "" ? Newfile.name.split(".")[0] : titleManu;
    const nodeid = AttachmentNodeid;
    props.createGenericAttachment(
      {lang, description, file, isattachmentof, specifier, title, nodeid},
      "genericAttachment"
    );
    handleClose();
  };

  
  const submitFormInternal = (e) => {

    e.preventDefault();
    if (NewfileInternal === undefined) {
      return;
    }
    /* if (descriptionInternal == "") {
        alert('Please Enter Description !')
        return;
    } */

    const url = uploadUrlInternal;
    const config = {
      headers: {
        "Content-Type": NewfileInternal?.type,
        "Access-Control-Allow-Origin": "*",
      },
    };
    const response = axios
      .put(url, NewfileInternal, config)
      .then((res) => {
        //console.log(res.data)
      })
      .catch(function(error) {
        //console.log(error);
      });
    const lang = "de";
    const file = {
      fileid: fileidInternal,
      mimetype: NewfileInternal.type,
      bucketid: bucketidInternal,
      fileversion: fileVersionInternal,
    };
    const isattachmentof = machines.equipment.nodeid;
    const description = descriptionInternal;
    const specifier = attachmentCategory;

    const title =
      titleInternal === ""
        ? NewfileInternal?.name?.split(".")[0]
        : titleInternal;
    const nodeid = AttachmentNodeid;
    props.createGenericAttachment(
      {lang, description, file, isattachmentof, specifier, title, nodeid},
      "genericAttachment"
    );

    setAttachmentCategory("");
    setNewfileInternal();
    setdescriptionInternal();
    settitleInternal();
    //props.getSingleMachine(machines.equipment.nodeid)
    //Internal_fileids.push(fileidInternal)
    //const fileids = Internal_fileids
    //props.getinternalattachments({fileids})
    setShowButton(true);
    handleCloseInternal();
  };

  /*
   * Styles
   */
  const useStyles = makeStyles()((theme) => ({
    documentationContainer: {
      padding: "28px 24px",

      "& .CardButton": {
        // marginRight: 24
      },
    },
    sectionHeadlineSub: {
      marginTop: 20,
      marginBottom: 20,
    },
  }));
  const {classes} = useStyles();

  const receviedChildValues = (values) => {
    setfileid(values[0].fileid);
    setuploadUrl(values[1].url);
    setbucketid(values[2].bucketid);
    setFileVersion(values[3].fileversion);
    setNewfile(values[4].fileversion);
  };

  const receviedChildValuesInternal = (values) => {
    setfileidInternal(values[0].fileid);
    setuploadUrlInternal(values[1].url);
    setbucketidInternal(values[2].bucketid);
    setbucketidInternal(values[3].fileversion);
    setNewfileInternal(values[4].fileversion);
  };



  // //console.log("ndfjkfhkjdfjkds", AttachmentManufacturer)
  return (
    <div className={clsx(classes.documentationContainer, "")} c>
      {isOpenPDF && (
        <Lightbox
          large={large}
          alt="Image Here"
          hideZoom={false}
          showRotate={true}
          onClose={this.closeLightbox}
        />
      )}
      <div className={`docsHeader ${_s(Theme247.sectionHeader)}`}>
        <Typography variant="h1">{i18n.heading_documentation}</Typography>
        {canUserPerformAction(
          props.profile?.features?.["equipment.attachment"],
          "create"
        ) && (
          <Grid item xs={4}>
            {/* <CardButton title={i18n.add_ressource} icon={<AddIcon />} iconcolor="disabled" size="large" onClick={handleClickOpenInternal} /> */}
            <Button
              variant="contained"
              color="primary"
              size="small"
              // className={_s(Theme247.submitButton)}
              startIcon={<AddIcon />}
              onClick={handleClickOpenInternal}
            >
              {i18n.add_ressource}
            </Button>
          </Grid>
        )}
      </div>

      <Grid
        container
        spacing={1}
        style={{
          marginTop: "10px",
          marginLeft: "0px",
          width: "100%",
          gap: "20px",
        }}
      >
  
        {categoryItems.map((item, index) => (
          <DragAndDropAccordian
            item={item}
            handleClickOpenInternal={handleClickOpenInternal}
            setAttachmentCategory={setAttachmentCategory}
            attachmentCategory={attachmentCategory}
          />
        ))}

     
      </Grid>

      <Dialog
        open={openDialogVideo}
        onClose={() => {
          handleCloseDialogVideo();
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        sx={{backdropFilter: "blur(4px)"}}
      >
        <DialogContent>
          <ReactPlayer
            url={videoUrl}
            controls={true}
            width="500px"
            height="500px"
          />
        </DialogContent>
      </Dialog>

      <Dialog
        open={openDialog}
        onClose={() => {
          handleCloseDialog();
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        sx={{backdropFilter: "blur(4px)"}}
        TransitionComponent={Zoom}
      >
        <DialogTitle id="alert-dialog-title">{"PDF Document"}</DialogTitle>
        <DialogContent>
          <a href={pdfLink} target="_blank">
            {i18n.download}
          </a>
          <br></br>
          <Document
            file={pdfLink}
            onLoadSuccess={(pdf) => {
              onDocumentLoadSuccess(pdf.numPages);
            }}
            style={{width: "50px", height: "50px"}}
          >
            <Page pageNumber={pageNumber} />
            <div>
              <Button
                onClick={() => {
                  handlePrevPage();
                }}
                style={{float: "left"}}
                color="primary"
                disabled={prevDisabled}
              >
                {i18n.previous}
              </Button>
              <text
                style={{
                  marginLeft: "90px",
                  marginTop: "10px",
                }}
              >
                {i18n.page} {pageNumber} {i18n.ofPage} {numPages}
              </text>
              <Button
                onClick={() => {
                  handleNextPage();
                }}
                style={{float: "right"}}
                color="primary"
                disabled={nextDisabled}
              >
                {i18n.next}
              </Button>
            </div>
          </Document>
        </DialogContent>
      </Dialog>

      <UploadAttachmentModal
        hasTitle
        hasDescription
        open={UploadDialogInternal}
        onClose={handleCloseInternal}
        customFileChange={handleNewFileInternal}
        file={NewfileInternal}
        setFile={setNewfileInternal}
        handleSubmit={submitFormInternal}
        description={descriptionInternal}
        setDescription={setdescriptionInternal}
        title={titleInternal}
        setTitle={settitleInternal}
        setTarget={setTarget}
        target={target}
        showButtn={showButtn}
        setShowButton={setShowButton}
        setAttachmentCategory={setAttachmentCategory}
        attachmentCategory={attachmentCategory}
        fromDragAndDrop
      />
    </div>
  );
});
